import { render, staticRenderFns } from "./doctorRegister.vue?vue&type=template&id=8e82ac78&"
import script from "./doctorRegister.vue?vue&type=script&lang=js&"
export * from "./doctorRegister.vue?vue&type=script&lang=js&"
import style0 from "./doctorRegister.vue?vue&type=style&index=0&id=8e82ac78&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports